import React, { useEffect } from 'react';
import { ErrorPage } from '@gjensidige/se-error-page';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';

import { useAppDispatch, useAppSelector } from '../../../hooks/appHooks';
import { SESSION_KEYS } from '../../../lib/constants/appConstants';
import {
  updateErrorStatus,
  updateLoadingStatus
} from '../../../store/slices/offerSlice';
import tracker from '../../../tracking';
import { ErrorStatus } from '../../../interfaces/Types';
import { TrackingHelper } from '../../../utils/TrackingHelper';
import { errorFunctionalityHandlerTemporary } from './TemporaryErrorPageHelper';

export const ErrorPageHandler: React.FunctionComponent<{children: React.ReactNode}> = ({ children }) => {
  
  const dispatch = useAppDispatch();
  const errorStatus: ErrorStatus = useAppSelector(
    (state) => state.insurance.offer.errorStatus
  );
  const productName = useAppSelector(
    (state) => state.insurance.offer.productName
  );

  const genericIllustrations = JSON.parse(
    sessionStorage.getItem(SESSION_KEYS.GENERIC_ILLUSTRATIONS) || '{}'
  );
  const errorPageIllustration = fetchGenericIllustrations(
    'ExclamationErrorModalNCI',
    IllustrationType.SIMPLE,
    genericIllustrations
  );
  const getScenarioStep = (errorStatus: ErrorStatus) =>{
    if (errorStatus.statusCode === 557) {
      return 'no_main_product';
    }
    return errorStatus.shouldAllowRetry ? 'error_calculation' : 'error_user';
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (errorStatus.shouldDisplayError) {
      let scenarioStep = getScenarioStep(errorStatus);
      tracker.trackScenerioStep(
        'error',
        TrackingHelper.getScenarioNameFromProduct(productName),
        scenarioStep
      );
    }
  }, []);

  const ButtonAndText = errorFunctionalityHandlerTemporary(
    errorStatus.statusCode,
    errorStatus.shouldAllowRetry,
    productName
  );

  return (
    <>
      {errorStatus.shouldDisplayError ? (
        <ErrorPage
          headingText={errorStatus.errorPageHeader}
          descriptionText={errorStatus.errorPageDescription}
          primaryButtonLabel={ButtonAndText.primaryButtonLabel}
          primaryBtnOnClick={ButtonAndText.primaryButtonOnClick}
          secondaryBtnLabel={ButtonAndText.secondaryButtonLabel}
          secondaryBtnOnClick={ButtonAndText.secondaryButtonOnClick}
          shouldDisplaySecondaryBtn={errorStatus.shouldAllowRetry}
          imageSrc={errorPageIllustration}
        />
      ) : (
        <>{children}</>
      )}
    </>
  );
};
